import React from "react";
import { connect } from "react-redux";
import { getKey } from "../../../../helpers/UrlHelper";
import { Label } from 'reactstrap';
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

class UserPage extends React.Component {
    state = {
        badgeNo: null,
    }
    componentDidUpdate(prevProps) {
        if (window.location && window.location.search && this.props.attendee.loading === false && this.state.badgeNo === null) {
            const params = new URLSearchParams(window.location.search);
            const badgeNo = params.get(getKey('badgeno', params))
            const { attendee } = this.props;
            if (badgeNo && attendee && attendee.orders && attendee.orders.length > 0 && this.props.attendee.orders[0].orderId !== undefined)
                this.setState({ badgeNo: this.props.attendee.orders[0].badgeNo })
            else {
                this.setState({ badgeNo: 'NOT_VALID' });
            }
        }
    }
    renderFrame = () => {
        const { badgeNo } = this.state;
        if (badgeNo && badgeNo !== 'NOT_VALID') {
            return (
                <React.Fragment>
                    OldWebConfLayout
                </React.Fragment>)
        }
        return <div style={{
            height: '200px',
            margin: 'auto',
            padding: '57px',
            textAlign: 'center',
            border: '3px dashed #8080807a',
            fontSize: '20px',
            color: '#595959'
        }}>
            <ErrorOutlineIcon style={{ fontSize: '50px', color: 'inherit' }} /><br />
            <SystemLabel groupName={"Page.Edit"} name="NotAValidBadgeNo" languageCode={this.props.page.languageCode || "swe"}
            />
        </div>
    }
    render() {
        const { badgeNo } = this.state;
        const { element, cms, attendee } = this.props;
        if (element === undefined || (element && element.data && element.data.hidden)) return null;
        return (
            <div
                style={{
                    padding: element.data.padding + "px",
                    margin: element.data.margin + "px",
                    backgroundColor: element.data.backgroundColor,
                    width: "100%"
                }}
                className={
                    element.parentName !== undefined && element.props.type !== "MAP"
                        ? "responsive-col resposive-hf-col"
                        : ""
                }
            >
                {cms.editMode ?
                    <div style={{ width: '100%', height: 'auto', padding: '10px', textAlign: 'center', backgroundColor: 'rgb(226, 225, 225)' }}><i className="fa fa-id-card" style={{ fontSize: '4rem', color: '#313131c2' }} /><br />
                        <Label><SystemLabel name="UserPage" /></Label>
                        <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="DoesNotShowInEditmode" /></p></em>
                    </div>
                    :
                    (badgeNo ?
                        this.renderFrame()
                        : <div style={{
                            height: '200px',
                            margin: 'auto',
                            padding: '57px',
                            textAlign: 'center',
                            border: '3px dashed #8080807a',
                            fontSize: '20px',
                            color: '#595959'
                        }}>
                            <VisibilityOffOutlinedIcon style={{ fontSize: '50px', color: 'inherit' }} /><br />
                            <SystemLabel groupName={"Page.Edit"} name="YouNeedToBeLoggedInToViewTHisPage" languageCode={this.props.page.languageCode || "swe"}
                            />
                        </div>)
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedElement: state.form.selectedElement,
        form: state.form,
        page: state.page,
        template: state.template.template,
        cms: state.cms,
        attendee: state.attendee
    };
}
export default connect(mapStateToProps)(UserPage);
